import { defaultsConfig } from "~config/sport/defaults";
import { PeriodTypes } from "~enums/periodTypes.ts";
import { Roles } from "~enums/roles";
import { RosterPosition } from "~enums/rosterPosition";
import type { SportConfiguration } from "~types/sportConfiguration";

const seasonOfficialRoles: Array<Roles> = [
  Roles.CrewChief,
  Roles.Groundskeeper,
  Roles.Referee,
  Roles.RefereeAssistant,
  Roles.RefereeAssistantReserve,
  Roles.RefereeReserve,
  Roles.Scorer,
  Roles.ScorerAssistant,
  Roles.ShotClockOperator,
  Roles.Statistician,
  Roles.Timer,
  Roles.Umpire,
  Roles.Umpire1,
  Roles.Umpire2,
  Roles.Commissioner,
  Roles.Committee,
  Roles.General,
  Roles.President,
  Roles.PresidentVice,
  Roles.Treasurer,
];

const fixtureOfficialRoles: Array<Roles> = [...seasonOfficialRoles];

const rosterPositions = [RosterPosition.Goalie, RosterPosition.Skater];

export const ice3Config: SportConfiguration = {
  ...defaultsConfig,
  seasonOfficialRoles,
  fixtureOfficialRoles,
  rosterPositions,
  periods: {
    [PeriodTypes.Period1]: { intlKey: "period.period1" },
    [PeriodTypes.Period2]: { intlKey: "period.period2" },
    [PeriodTypes.Period3]: { intlKey: "period.period3" },
    [PeriodTypes.Period4]: { intlKey: "period.period4" },
    [PeriodTypes.ExtraPeriod0]: { intlKey: "period.extraTime1" },
    [PeriodTypes.ExtraPeriod1]: { intlKey: "period.shootout" },
  },
};
